import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-wgv-unfiltered',
  templateUrl: './wgv-unfiltered.component.html',
  styleUrl: './wgv-unfiltered.component.scss',
  imports: [CommonModule, FormsModule],
})
export class WgvUnfilteredComponent implements OnInit {
  private http = inject(HttpClient);
  private meta = inject(Meta);
  private title = inject(Title);

  nome: string = '';
  cognome: string = '';
  tipoPanino: string = '';
  bibita: string = '';
  senzaGlutine: boolean = false;
  senzaLattosio: boolean = false;

  isSubmitting: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';

  ngOnInit() {
    this.title.setTitle(
      'WGV Unfiltered - Conferenza su relazioni, sessualità | 17 Gennaio - Come Tralci'
    );

    this.meta.updateTag({
      name: 'description',
      content:
        'Iscriviti a WGV Unfiltered: una conferenza senza filtri su relazioni, sessualità e pornografia con Antonio Morra. Sabato 17 Gennaio ore 17:00. Evento gratuito con pizza inclusa.',
    });
    this.meta.updateTag({
      name: 'keywords',
      content:
        'WGV Unfiltered, conferenza giovani, relazioni, sessualità, Antonio Morra, Giovani Valorosi, evento gratuito, Come Tralci',
    });

    // Open Graph tags per social sharing
    this.meta.updateTag({
      property: 'og:title',
      content: 'WGV Unfiltered - Conferenza senza filtri | 17 Gennaio',
    });
    this.meta.updateTag({
      property: 'og:description',
      content:
        'Una conferenza senza filtri su relazioni, sessualità e pornografia con Antonio Morra. Sabato 17 Gennaio ore 17:00.',
    });
    this.meta.updateTag({ property: 'og:type', content: 'event' });
    this.meta.updateTag({
      property: 'og:url',
      content: 'https://cometralci.com/wgv/unfiltered',
    });
    this.meta.updateTag({ property: 'og:site_name', content: 'Come Tralci' });
    this.meta.updateTag({ property: 'og:locale', content: 'it_IT' });

    // Twitter Card
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({
      name: 'twitter:title',
      content: 'WGV Unfiltered - Conferenza senza filtri',
    });
    this.meta.updateTag({
      name: 'twitter:description',
      content:
        'Conferenza su relazioni, sessualità e pornografia. 17 Gennaio ore 17:00.',
    });

    // Canonical URL
    this.meta.updateTag({
      rel: 'canonical',
      href: 'https://cometralci.com/wgv/unfiltered',
    });
  }

  onSubmit() {
    this.isSubmitting = true;
    this.successMessage = '';
    this.errorMessage = '';

    const payload = {
      nome: this.nome,
      cognome: this.cognome,
      tipoPanino: this.tipoPanino,
      bibita: this.bibita,
      senzaGlutine: this.senzaGlutine,
      senzaLattosio: this.senzaLattosio,
    };

    this.http
      .post(`${environment.apiUrl}/iscrizioni-unfiltered`, payload)
      .subscribe({
        next: () => {
          this.isSubmitting = false;
          this.successMessage = 'Iscrizione completata con successo!';
          this.nome = '';
          this.cognome = '';
          this.tipoPanino = '';
          this.bibita = '';
          this.senzaGlutine = false;
          this.senzaLattosio = false;
        },
        error: () => {
          this.isSubmitting = false;
          this.errorMessage = 'Si è verificato un errore. Riprova più tardi.';
        },
      });
  }
}
